<template>
  <div class="row tasks-archive">
    <div class="col">
      <div class="row">
        <div class="col">
          <h1>Всего задач в архиве: {{ tasksCount }}</h1>
          <form class="form-inline py-2 justify-content-end" @submit.prevent>
            <div class="input-group with-clear-icon">
              <input type="text" class="form-control" v-model="searchText" />
              <i
                class="ico ico-close"
                @click="clearSearchText"
                v-if="searchText.length > 0"
              ></i>
              <div class="input-group-append">
                <span class="input-group-text"
                  ><i class="fa fa-search"></i
                ></span>
              </div>
            </div>
          </form>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th
              v-for="column in tableColumns"
              :key="column.fieldName"
              @click="columnClick(column.sortName)"
              class="table_th"
              :class="{
                'sort-asc':
                  column.sortName === sortColumn && sortDirection === 'ASC',
                'sort-desc':
                  column.sortName === sortColumn && sortDirection === 'DESC',
                sort: column.sortName !== sortColumn,
              }"
              :style="{
                width:
                  (column.width * 100) /
                    tableColumns.map((x) => x.width).reduce((a, b) => a + b) +
                  '%',
              }"
            >
              <div>{{ $t(column.name) }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in tableRows"
            :key="row.taskId"
            @click="rowClick(row.taskId)"
          >
            <td
              v-for="cell in row.cells"
              :key="cell.id"
              :class="[cell.cellClasses]"
            >
              <div class="td-content td-content-lg" :title="cell.value">
                <template v-if="cell.fieldName === 'ctid'">
                  {{ cell.value }}
                  <span
                    class="unreaded-messages-pill"
                    v-show="+cell.countNotReadComments"
                    >{{ cell.countNotReadComments }}</span
                  >
                </template>
                <template v-else-if="cell.fieldName === 'taskName'">
                  <router-link
                    v-if="isAdAgent"
                    :to="{ path: `/ad-agent/view-task/${row.taskId}` }"
                  >
                    {{ cell.value }}
                  </router-link>
                  <router-link
                    v-else
                    :to="{ path: `/view-task/${row.taskId}` }"
                  >
                    {{ cell.value }}
                  </router-link>
                </template>
                <template v-else>
                  {{ cell.value }}
                </template>
              </div>
            </td>
          </tr>
          <tr v-if="isShowLoader">
            <td :colspan="tableColumns.length" class="td-content text-center">
              <div class="tasks-archive__loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import axios from 'axios'
import tableHelper from '../../helpers/tableHelper'

import api from '../../api'
import roles from '../../helpers/userRoles'

const sortTypes = {
  ASC: 'ASC',
  DESC: 'DESC'
}

export default {
  name: 'TasksArchive',
  data () {
    return {
      searchText: '',
      lazySearchText: '',
      isShowLoader: true,
      sortColumn: null,
      sortDirection: sortTypes.DESC,
      tasks: [],
      tasksCount: null,
      skip: 0,
      limit: 100,
      checkScroll: debounce(this.checkPageScroll, 1000)
    }
  },
  computed: {
    isAdAgent () {
      return this.$store.getters.role === roles.adAgent
    },
    tableColumns: function () {
      if (this.isAdAgent) {
        return tableHelper.getAdAgentRequestColumns()
      }
      return tableHelper.getColumns(this.$store.getters.role)
    },
    tableRows: function () {
      return this.tasks.map((task) => {
        return tableHelper.getArchiveRow(task, this.tableColumns)
      })
    },
    requestPayload () {
      const sortColumn = this.getSortColumn()
      const sort = { [sortColumn]: this.sortDirection }
      const find = this.lazySearchText
      return { sort, find, skip: this.skip, limit: this.limit }
    }
  },
  async created () {
    this.sortColumn = this.tableColumns[0].sortName
    await this.loadTasks()
  },
  mounted () {
    window.addEventListener('scroll', this.checkScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.checkScroll)
  },
  watch: {
    searchText: debounce(function (newValue) {
      this.clearFilters()
      this.lazySearchText = newValue
      this.tasks = []
    }, 300),
    async requestPayload () {
      await this.loadTasks()
    }
  },
  methods: {
    clearFilters () {
      this.skip = 0
    },
    checkPageScroll () {
      if (
        document.documentElement.scrollHeight -
          document.documentElement.scrollTop.toFixed() -
          document.documentElement.clientHeight <=
          10 &&
        document.documentElement.scrollTop > 0
      ) {
        if (
          this.tasksCount > this.tasks.length &&
          this.tasks.length >= this.limit
        ) {
          this.skip += this.limit
        } else {
          this.isShowLoader = false
        }
      }
    },
    getSortColumn () {
      switch (this.sortColumn) {
        case 'taskName':
          return 'name'
        case 'client':
          return 'client_name'
        case 'afterPrinter':
          return 'after_printer'
        case 'startDate':
          return 'start_time'
        case 'endDate':
          return 'end_time'

        default:
          return this.sortColumn
      }
    },
    async loadTasks () {
      try {
        this.isShowLoader = true
        const resp = await api.post.finishedTasks(this.requestPayload)
        this.tasks = this.skip
          ? [...this.tasks, ...resp.data.data.tasks]
          : resp.data.data.tasks
        this.tasksCount = resp.data.data.countAll
        if (this.tasks.length < this.limit) {
          this.isShowLoader = false
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          return
        }
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    clearSearchText () {
      this.searchText = ''
    },
    rowClick (taskId) {
      if (this.isAdAgent) {
        this.$router.push({ path: `/ad-agent/view-task/${taskId}` })
      } else {
        this.$router.push({ path: `/view-task/${taskId}` })
      }
    },
    columnClick (sortName) {
      this.clearFilters()
      if (this.sortColumn === sortName) {
        this.sortDirection =
          this.sortDirection === sortTypes.ASC ? sortTypes.DESC : sortTypes.ASC
      } else {
        this.sortColumn = sortName
        this.sortDirection = sortTypes.ASC
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.$eventBus.$emit('pageHeaderChange', 'Задачи')
    })
  }
}
</script>

<style lang="scss">
.tasks-archive {
  .table_th {
    position: sticky;
    top: 50px;
    z-index: 1;
  }

  &__loader {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;

    & div {
      position: absolute;
      top: 33px;
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background: #28bd8b;
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }

    & div:nth-child(1) {
      left: 8px;
      animation: loader-ellipsis1 0.6s infinite;
    }

    & div:nth-child(2) {
      left: 8px;
      animation: loader-ellipsis2 0.6s infinite;
    }

    & div:nth-child(3) {
      left: 32px;
      animation: loader-ellipsis2 0.6s infinite;
    }

    & div:nth-child(4) {
      left: 56px;
      animation: loader-ellipsis3 0.6s infinite;
    }

    @keyframes loader-ellipsis1 {
      0% {
        transform: scale(0);
      }
      100% {
        transform: scale(1);
      }
    }
    @keyframes loader-ellipsis3 {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(0);
      }
    }
    @keyframes loader-ellipsis2 {
      0% {
        transform: translate(0, 0);
      }
      100% {
        transform: translate(24px, 0);
      }
    }
  }
}
</style>
